import { toProfilePictureDisplayPath } from './profilePicture'

/** Build a browser-loadable URL for upload files (production: always under /api/uploads). */
export const toUploadUrl = (url?: string | null): string => {
  const trimmed = String(url || '').trim()

  if (!trimmed) return ''
  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed
  }

  if (
    trimmed.includes('profile-pictures') ||
    trimmed.includes('non-teaching-staff-photos') ||
    (!trimmed.includes('/') && !trimmed.includes('\\') && /\.(jpe?g|png|gif|webp|jfif)$/i.test(trimmed))
  ) {
    return toProfilePictureDisplayPath(trimmed) || trimmed
  }

  if (trimmed.startsWith('/api/')) return trimmed
  if (trimmed.startsWith('/uploads/')) return `/api${trimmed}`
  if (trimmed.startsWith('uploads/')) return `/api/${trimmed}`

  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}
